import "./Navbar.css";
import fullIcon from "../images/White@svg-bold.svg";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faNavicon,
  faMagnifyingGlass,
  faShoppingCart,
  faXmarkCircle,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";

//hooks
import { useRoute } from "../../hooks/useRoute";
import { useCart } from "../../hooks/useCart";
import { useFavorites } from "../../hooks/useFavorites";
import { useUser } from "../../hooks/useUser";
import { usePreviousOrder } from "../../hooks/usePreviousOrder";

// Helper function to format date from MM/DD/YYYY to "Fri, 27 Mar"
const formatDateToReadable = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const options = { weekday: "short", day: "numeric", month: "short" };
  return date.toLocaleDateString("en-US", options).replace(",", ",");
};

const Navbar = ({
  handleSearch,
  handleSidebar,
  handleOpenSearchModal,
  notification,
  handleNotification,
}) => {
  const { cartTotal, itemCount } = useCart();
  const { favorites } = useFavorites();
  const { route } = useRoute();
  const { user } = useUser();
  const { previousOrderInfo } = usePreviousOrder();

  // Only show the user's saved location when it exists in the current route's dropLocations
  const dropLocationNames =
    route && route.dropLocations ? route.dropLocations.map((d) => d.name) : [];
  const locationToShow =
    user && user.location && dropLocationNames.includes(user.location)
      ? user.location
      : "Parsons";

  const [searchTerm, setSearchTerm] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch(searchTerm);
  };

  const navigate = useNavigate();

  const navigateToCart = () => {
    navigate("/cart");
  };

  const navigateToFavorites = () => {
    navigate("/favorites");
  };

  return (
    <>
      <nav className="navbar grid">
        <div className="menuIcon">
          <FontAwesomeIcon
            icon={faNavicon}
            className="navicon"
            onClick={handleSidebar}
          />
        </div>
        <Link to="/" className="navbar-full-logo">
          <img src={fullIcon} alt="" />
        </Link>
        <Link to="/" className="navbar-short-logo">
          <img src={fullIcon} alt="" />
        </Link>
        <div className="searchBar">
          <form onSubmit={handleSubmit} className="searchbox">
            <input
              type="text"
              className="searchBox"
              placeholder="Search everything at Granddad's Groceries online and in store"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
            />
            <button className="navButton" type="submit">
              Search
            </button>
          </form>
        </div>
        <div className="searchIcon">
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            className="navicon"
            onClick={handleOpenSearchModal}
          />
        </div>
        <div className="favoritesIcon">
          <FontAwesomeIcon
            icon={faHeart}
            className="navicon"
            onClick={navigateToFavorites}
          />
          {favorites.length > 0 && (
            <p
              className={
                favorites.length > 9
                  ? "itemCount aboveTen"
                  : "itemCount belowTen"
              }
            >
              {favorites.length}
            </p>
          )}
        </div>
        <div className="cartIcon">
          <FontAwesomeIcon
            icon={faShoppingCart}
            className="navicon"
            onClick={navigateToCart}
          />
          {cartTotal > 0 && (
            <p className="cartAmount">
              ${Number.parseFloat(cartTotal / 100).toFixed(2)}
            </p>
          )}
          {itemCount > 0 && (
            <p
              className={
                itemCount > 9 ? "itemCount aboveTen" : "itemCount belowTen"
              }
            >
              {itemCount}
            </p>
          )}
        </div>
      </nav>
      {notification &&
        !route.ordersOpen &&
        route.nextOrderWindow &&
        route.orderCities && (
          <div className="navbar-order-window grid">
            <Link to="/pickup-times" className="navbar-notification-link">
              <p className="navbar-order-text">
                Next Order Week: <b>{route.nextOrderWindow}</b>
                {" for pick-ups in "}
                <b>{route.orderCities}</b>
              </p>
            </Link>
            <FontAwesomeIcon
              icon={faXmarkCircle}
              className="navbar-order-icon"
              onClick={handleNotification}
            />
          </div>
        )}
      {notification && route.ordersOpen && previousOrderInfo && (
        <div className="navbar-order-window grid">
          <Link to="/cart" className="navbar-notification-link">
            <p className="navbar-order-text">
              You have{" "}
              <b>
                {previousOrderInfo.daysRemaining < 1
                  ? "until end of day today"
                  : `${previousOrderInfo.daysRemaining} ${
                      previousOrderInfo.daysRemaining === 1 ? "day" : "days"
                    }`}
              </b>{" "}
              remaining to add to your order for{" "}
              <b>{previousOrderInfo.fulfillmentDate}</b>.
            </p>
          </Link>
          <FontAwesomeIcon
            icon={faXmarkCircle}
            className="navbar-order-icon"
            onClick={handleNotification}
          />
        </div>
      )}
      {notification && route.ordersOpen && !previousOrderInfo && (
        <div className="navbar-order-window grid">
          <Link to="/cart" className="navbar-notification-link">
            <p className="navbar-order-text">
              Orders now open for <b>{locationToShow}</b> with{" "}
              <b>{formatDateToReadable(route.nextDeliveryDate)}</b> pick-up!
              Order Deadline: <b>{formatDateToReadable(route.orderDeadline)}</b>
            </p>
          </Link>
          <FontAwesomeIcon
            icon={faXmarkCircle}
            className="navbar-order-icon"
            onClick={handleNotification}
          />
        </div>
      )}
      {notification && (
        <div className="navbar-order-window grid">
          <Link to="/pickup-times" className="navbar-notification-link">
            <p className="navbar-order-text">
              See other pickup times & locations here.
            </p>
          </Link>
        </div>
      )}
    </>
  );
};

export default Navbar;
